import { useEffect, useRef, useState } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import SubHeader from "../../components/SubHeader";
import BundlesList from "../../components/EsimBundles";
import { ScrollTo } from "../../utils/ScrollTo";
import './Pricing.scss'
import { useToast } from "../../context/ToastContext";
import { useDispatch } from "react-redux";
import { authActions } from "../../store/auth";
import { verifyWebviewAuthTokenApi } from "../../services/api";

const Pricing = () => {
  const { labels, general } = useToast();
  const [jwtStatus, setJwtStatus] = useState("");
  
  const ref = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    ScrollTo(ref, -300);
  });

  useEffect(() => {
    localStorage.removeItem("PAYMENT-RESPONSE");
  }, []); 

  useEffect(() => {
    if (window?.webviewData?.jwt) {
      const verifyJwtTokenHandler = () => {
        setJwtStatus("authentication-required");
        const getLoginResponse = (response) => {
          if (response.result === "SUCCESS") {
            setJwtStatus("authenticated");
            dispatch(authActions.onLogin(response.data));
          } else {
            setJwtStatus("authentication-failed");
          }
        };
        verifyWebviewAuthTokenApi(
          { token: window?.webviewData?.jwt },
          dispatch,
          getLoginResponse
        );
      };

      verifyJwtTokenHandler();
    }
  }, [dispatch]);

  return (
   jwtStatus === "authentication-failed"
     ? <h1>Authentication failed</h1>
     : <HelmetProvider> 
      <Helmet>
          <meta charSet="utf-8" />
          <title>{`${general.GEN0001} | ${labels.LBL0066}`}</title>
      </Helmet>
      <div className="pricing-page">
        <SubHeader/>
      </div>
       {/* Plans Section*/}
      <section className="plan-section">
        <div className="grid align-items-center">
          <h2>{labels.LBL0155}</h2>
        </div>
        <div className="card">
          <div className="bundles-section" ref={ref}>
            <BundlesList />
          </div>
        </div>
      </section>

    </HelmetProvider>
  );
};

export default Pricing;